import { Component, KeyValueDiffers, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { User } from '../Models/FitnessBox/User';
import { CommonDataService } from '../Services/commonDataService';
import { AppContext } from '../Shared/common';
import { Screen } from '../Models/Screen';

@Component({
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit {

  constructor(private router: Router,
    private _service: CommonDataService,
    private differs: KeyValueDiffers,
    private route: ActivatedRoute,
    private appctx: AppContext
  ) {
    this.currentUser = appctx.CurrentUser;
  }

  title = 'Icon Fitness';
  hasSpecialAccess: boolean = false;
  currentUser: User = null;

  ngOnInit() {
    this.processScreenAccess();
  }

  processScreenAccess() {
    if (this.appctx.CurrentScreen && this.appctx.CurrentScreen.HasSpecialPermissions) {
      this.hasSpecialAccess = true;
    }
  }

}
